var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevelUpBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3137 22.4744C19.8143 21.9694 19.4566 21.1111 18.7456 21.1111H16.945C16.354 21.1111 15.967 20.4922 16.2258 19.9608L18.8966 14.4766C19.0306 14.2014 19.3098 14.0269 19.6159 14.0269H24.8791C25.5166 14.0269 25.898 13.3176 25.5465 12.7858L17.573 0.719762C17.3163 0.331337 16.7834 0.243296 16.4154 0.528513L0.847949 12.5945C0.245358 13.0616 0.575637 14.0269 1.33804 14.0269H6.78059C7.41774 14.0269 7.79921 14.7354 7.44843 15.2673L2.75584 22.3829C2.40506 22.9148 2.78654 23.6233 3.42369 23.6233H6.25464C6.80005 23.6233 7.18556 24.1571 7.01406 24.6749L3.00914 36.7657C2.74337 37.568 3.74158 38.1807 4.33667 37.5805L19.3137 22.4744Z",
    fill: "url(#paint0_linear_301_509)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_509",
    x1: 12.6833,
    y1: 0,
    x2: 12.6833,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADB38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0BD06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0BD06"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelUpBolt);
export default __webpack_public_path__ + "static/media/level-up-bolt.75523e809d65faeb16fc900770bd8494.svg";
export { ForwardRef as ReactComponent };